import axios from 'axios'
import { ENV } from '../config'
import { getToken } from './token'
import { md5Http, collectApiMap } from './common'


class CustomLog {
  constructor () {
    this.isUpload = ENV === 'uat' || ENV === 'prd'
    // this.logs = {}
    // this.xhrList = []
    // this.countThreshold = 5
    // this.timeThreshold = 3
    // if (this.isUpload) {
    //   window.setInterval(this.checkList.bind(this), this.timeThreshold * 1000)
    // }
  }

  push (option) {
    if (this.isUpload) {
      let userId = window.__ERPUSER__ ? window.__ERPUSER__.id : ''
      let menuId = window.__ERPMODULE__ ? window.__ERPMODULE__.id : ''
      let now = Date.now()
      let defaultOption = {
        action: '',
        path: '',
        bizId: '',
        type: '',
        userId,
        menuId,
        startTime: now,
        endTime: now,
        url: window.location.href,
        navigator: navigator.userAgent,
        webTraceId: `${userId}-${menuId}-${now}`,
      }
      option = {...defaultOption, ...option}
      // this.xhrList.push()
      this.upload([option])
    }
  }

  // checkList () {
  //   if (this.xhrList.length && this.xhrList.some(item => item.immediate)) {
  //     console.log('[自定义埋点] 立即上报')
  //     this.upload()
  //     this.clearList()
  //   }
  //   if (this.xhrList.length >= this.countThreshold) {
  //     console.log('[自定义埋点] 达到采集量上报')
  //     this.upload()
  //     this.clearList()
  //   }
  //   if (!this.xhrList.length) return
  //   if ((+new Date() - this.xhrList[0].startTime) / 1000 > this.timeThreshold) {
  //     console.log(`[自定义埋点] 超时上报: ${this.timeThreshold} 秒`)
  //     this.upload()
  //     this.clearList()
  //   }
  // }

  // clearList () {
  //   this.xhrList = []
  // }

  upload (xhrList) {
    let token = getToken()
    let now = Date.now()
    const baseUrl = collectApiMap[ENV] || collectApiMap['uat']
    axios({
      url: baseUrl,
      method: 'post',
      data: xhrList,
      timeout: 20000,
      headers: {
        token,
        method: 'cts.erp.uploadChildActionLog',
        timestamp: now,
        sign: md5Http(token, now, xhrList),
        'X-Env': ENV || 'uat'
      }
    })
  }
}

export default new CustomLog()



// WEBPACK FOOTER //
// ./src/public/utils/custom-log.js